/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { TabValue } from "../config";

interface LoadingStateProps {
  tab: TabValue;
}

export const LoadingState = defineComponent<LoadingStateProps>({
  name: "LoadingState",
  props: ["tab"] as any,
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <div class="flex items-center justify-center h-full min-h-[400px]">
        <div class="text-center">
          <span class="loading loading-spinner loading-lg text-primary"></span>
          <p class="mt-4 text-sm text-base-content/60">
            {props.tab === "reservations"
              ? t("reservations.general.loading_reservations")
              : t("reservations.history.loading_requests")}
          </p>
        </div>
      </div>
    );
  },
});
